import { Deserialize, IJsonObject } from 'dcerialize';
import { Grant, GrantList } from '../models/grant';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { CustomSnackbarService } from './custom-snackbar.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/';

@Injectable({
  providedIn: 'root'
})
export class GrantService {
  constructor(
    protected http: HttpClient,
    private snackbarService: CustomSnackbarService,
    private apiService: ApiService
  ) {}

  get path(): string {
    return this.apiService.getApiUrl() + 'grant';
  }

  /**
   * Create grant method
   * @returns element retrieved user-profile from the CRUD service
   */
  create(grant: Grant): Observable<Grant> {
    return this.http.post<IJsonObject>(`${this.path}`, grant).pipe(
      map((grant) => Deserialize(grant, () => Grant)),
      catchError((err: HttpErrorResponse) => this.snackbarService.showError(err))
    );
  }

  /**
   * List grant method
   * @returns list of grants depending on the parameters sent
   */
  list(params?: Record<string, string>): Observable<GrantList> {
    return this.http.get<IJsonObject>(`${this.path}`, { params }).pipe(
      map((grant) => Deserialize(grant, () => GrantList)),
      catchError((err: HttpErrorResponse) => this.snackbarService.showError(err))
    );
  }

  delete(grantId: number): Observable<null> {
    return this.http.delete<null>(`${this.path}/${grantId}`);
  }

  editGrant(grant: Grant): Observable<Grant> {
    return this.http.put<Grant>(`${this.path}/${grant._id}`, grant);
  }
}
